<template>
  <div>

  </div>
</template>

<script>

export default {
  props: ['invoice', 'generalAllowEdit'],
  data() {
    return {
      sortedInvoiceStatuses: [
        {title: 'предварительная ведомость', id: 1},
        {title: 'в дороге', id: 2},
        {title: 'фактическое поступление', id: 0},
        {title: 'модерация', id: 3},
        {title: 'сборка', id: 4},
        {title: 'резерв', id: 5, invoiceTypeOnly: [1]},
      ],
    }
  }
}

</script>
